import { useEffect } from 'react';
import { toast } from 'sonner';
import { promosAPI } from '../services/api';
import { promoSession } from '../services/savings';

// Re-check the stored promo code each time the cart content changes (conditions like « with an engine oil » may no longer hold)
export const usePromoRevalidation = (items, promo, setPromo) => {
  const signature = (items || []).map(i => `${i.product_id}:${i.quantity}:${i.pack_id || ''}`).sort().join('|');
  useEffect(() => {
    if (!promo?.code || !items?.length || !localStorage.getItem('token')) return;
    let cancelled = false;
    promosAPI.validate(promo.code)
      .then(p => { if (!cancelled && (p.discount !== promo.discount || p.free_shipping !== promo.free_shipping)) { setPromo(p); promoSession.set(p); } })
      .catch(e => {
        if (cancelled) return;
        setPromo(null); promoSession.clear();
        toast.info(e.response?.data?.detail || `Code ${promo.code} retiré : conditions non remplies`);
      });
    return () => { cancelled = true; };
  }, [signature]); // eslint-disable-line react-hooks/exhaustive-deps
};
